import { render, staticRenderFns } from "./BankcardModal.vue?vue&type=template&id=3f849883&scoped=true&"
import script from "./BankcardModal.vue?vue&type=script&lang=ts&"
export * from "./BankcardModal.vue?vue&type=script&lang=ts&"
import style0 from "./BankcardModal.vue?vue&type=style&index=0&id=3f849883&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f849883",
  null
  
)

export default component.exports